import { generatePath } from "react-router-dom";
import { ValueFormatterParams } from "./formatters";
import { ROUTES } from "src/utils/constants/routes";

export const renderPlayerNameWithoutLink = (params: ValueFormatterParams) => params.value?.name;

export const renderPlayerNameWithLink = (params: ValueFormatterParams) => {
  const { id, teamID, name, status } = params.value ?? {};
  if (id && teamID && status === "active") {
    let route: string = ROUTES.teams.playerProfile;
    const generatedRoute = generatePath(route, {
      pid: id,
      id: teamID,
    });
    return `<a href="${generatedRoute}">${name}</a>`;
  } else {
    return name;
  }
};
